export const DE_PSEUDO_CARE_PROVIDER_SUCCESS = 'DE_PSEUDO_CARE_PROVIDER_SUCCESS';

export const dePseudoCareProviderSuccess = (careProvider, pseudonym) => ({
    type: DE_PSEUDO_CARE_PROVIDER_SUCCESS,
    payload: { careProvider, pseudonym },
});